import React, { useEffect, useContext, Suspense } from "react";
import { useState } from "react";
import { TostMsg } from "../../../App";
import { Link } from "react-router-dom";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import {
  deleteSurveyForm,
  getSurveyList,
  publishUnpublishSurveyForm,
  stopSurveyForm,
} from "./Services/surveyService";
import { getSurveySummary } from "./Services/surveyService";
import moment from "moment";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import InfiniteScroll from "react-infinite-scroll-component";
import { InputText } from "primereact/inputtext";

const SurvayList = () => {
  const [surveySummaryList, setSurveySummaryList] = useState([]);
  const [IsLoading, setLoading] = useState(false);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [surveyList, setSurveyList] = useState([]);
  const [surveyGUID, setSurveyGUID] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [pageSize] = useState(10);
  const toster = useContext(TostMsg);
  const [deleteFormId, setDeleteFormId] = useState([]);
  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "{}");
  const [create, setCreate] = useState(false);
  const [update, setUpdate] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  let history = useHistory();


  useEffect(() => {
  GetSurveySummary();
  permissionAccouncementList();
  GetSurveyList(1, true);
}, []);
  useEffect(() => {
    setPage(1);
    setHasMore(true);
    GetSurveyList(1, true);
  }, [searchTerm]);

  const permissionAccouncementList = () => {
    userPermissions.map((UserPermission) => {
      if (UserPermission.PermissionName == "Survey.Create") {
        setCreate(true);
      } else if (UserPermission.PermissionName == "Survey.Manage") {
        setUpdate(true);
      }
    });
  };

  async function GetSurveyList(pageNumber = 1, reset = false) {
    setLoading(true);
    const params = {
      FormId: 0,
      EmpGUID: "",
      FormGUID: "",
      PageNumber: pageNumber,
      PageSize: pageSize,
      EmpId: userDetails.OrgId,
      MyCreatedSurvey: 0,
      MyParticipation: 0,
      Search: searchTerm,
    };
    try {
      let data = await getSurveyList(params);
      // if (reset) {
      //   setSurveyList(data?.Data);
      //   setPage(1);
      // } else {
      //   setSurveyList((prev) => [...prev, ...data?.Data]);
      //   setPage(pageNumber);
      // }

      if (reset) {
  setSurveyList(data?.Data || []);
  setPage(1);
} else {
  setSurveyList((prev) => [...prev, ...(data?.Data || [])]);
  setPage(pageNumber);
}
      if (data?.Data?.length < pageSize) {
        setHasMore(false);
      } else {
        setHasMore(true);
      }
      // setSurveyGUID(data?.Data[0]?.FormGUID);

      setSurveyGUID(data?.Data?.[0]?.FormGUID);
      setLoading(false);
    } catch (error) {
      setHasMore(false);
      setLoading(false);
    }
  }

  const loadMoreSurveys = () => {
    if (!hasMore || IsLoading) return;
    GetSurveyList(page + 1, false);
  };

  const handlePublish = async (item) => { 
    try {
      const payload = {
        FormId: item.FormId,
        LoggedInUserId: userDetails?.EmpId,
      };
      await publishUnpublishSurveyForm(payload);
      setPage(1);
      setHasMore(true);
      GetSurveyList(1, true);
    } catch (error) {
      console.error("Publish failed", error);
    } finally {

    }
  };
  async function GetSurveySummary() {
    setLoading(true);
    try {
      let responce = await getSurveySummary({});
      setSurveySummaryList(responce?.Data);
    } catch (err) {
      toster.current.error(ERROR_LIST.DefaultError);
    } finally {
      setLoading(false);
    }
  }

  async function StopSurveyForm(FormId) {
    setLoading(true);
    let body = {
      FormId: FormId,
      LoggedInUserId: userDetails?.EmpId,
    };
    try {
      let res = await stopSurveyForm(body);
      if (res?.StatusCode === 2000) {
        setPage(1);
        setHasMore(true);
        GetSurveyList(1, true);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }

  async function DeleteSurveyForm() { 
    setLoading(true);
    if (deleteFormId) {
      let body = {
        FormId: deleteFormId,
        LoggedInUserId: userDetails?.EmpId,
      };
      setLoading(true);
      try {
        let res = await deleteSurveyForm(body);
        if (res?.StatusCode === 2000) {
          toster.current.success("Survey Deleted Successfully");
          setPage(1);
          setHasMore(true);
          GetSurveyList(1, true);
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        toster.current.error(ERROR_LIST.DefaultError);
      }
    }
  }

  return (
    <div>
      <div id="circular-menu" className="circular-menu">
        <a className="floating-btn">
          <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
          <i aria-hidden="true" className="fa fa-times"></i>
        </a>

        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </a>
          <Link to="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </a>
        </div>
      </div>
      {/* <!-- row --> */}
      <div className="container-fluid">
        <div className="row g-3 assessment-module">
          <div className="col-xl-12">
            <div className="form-head d-flex flex-wrap align-items-center">
              <div className="me-auto">
                <h2 className="font-w600 mb-0">Survey Dashboard</h2>
              </div>
              
              {/* {(create || update) && <div className="rightside-tabs me-2">
                <div className="actionbutton-tickets">
                                  <InputText
                                   name="requestTitle"
                                   className="form-control mr-2"
                                   placeholder="Search"
                                   value={searchTerm}
                                  onChange={(e) => setSearchTerm(e.target.value)}
/>
                                </div>
                <Link to="/Survey/Create">
                  {" "}
                  <button
                    className="add-newticket w-auto float-right"
                    style={{ minWidth: "fit-content" }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-plus"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                    </svg>
                    New Survey
                  </button>
                </Link>
              </div>} */}

              <div className="rightside-tabs me-2">
  <div className="actionbutton-tickets">
    <InputText
      name="requestTitle"
      className="form-control mr-2"
      placeholder="Search"
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
    />
  </div>

  {(create || update) && (

  <Link to="/Survey/Create">
    <button
      className="add-newticket w-auto float-right"
      style={{ minWidth: "fit-content" }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="currentColor"
        className="bi bi-plus"
        viewBox="0 0 16 16"
      >
        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
      </svg>
      New Survey
    </button>
  </Link>
  )}
</div>
            </div>
          </div>
          <div className="col-xl-12 mb-3">
            <div className="page-content-inner all-projects mt-0">
              <div className="survay-summary">
                {/* {surveySummaryList?.map((count, index) => ( */}
                <div className="row g-3">
                  {/* {surveySummaryList?.map((count, index) => ( */}
                  <div className="col-lg-3">
                    <div className="responses-card-summery">
                         <img src="/images/org-img/leave/popup-backimg.png" className="bg-img"/>
                      <h4>Total surveys</h4>
                      <div className="d-flex justify-content-between align-items-center">
                        {/* <div className="num-bx">{surveySummaryList[0]?.TotalSurveys || 0}</div> */}
                        <div className="num-bx">
                          {surveySummaryList?.find(
                            (item) => item.Key === "Total Surveys",
                          )?.Value ?? 0}
                        </div>
                        {/* <div className="img-bx text-dark">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            class="bi bi-people-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5.784 6A2.24 2.24 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.3 6.3 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1zM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
                          </svg>
                        </div> */}
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3">
                    <div className="responses-card-summery">
                      <img src="/images/org-img/leave/popup-backimg.png" className="bg-img"/>
                      <h4>Open surveys</h4>
                      <div className="d-flex justify-content-between align-items-center">
                        {/* <div className="num-bx">
                          {surveySummaryList[0]?.OpenSurveys ?? 0}
                        </div> */}

                        <div className="num-bx">
                          {surveySummaryList?.find(
                            (item) => item.Key === "Open Surveys",
                          )?.Value ?? 0}
                        </div>
                        {/* <div className="img-bx text-dark">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            class="bi bi-mortarboard-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8.211 2.047a.5.5 0 0 0-.422 0l-7.5 3.5a.5.5 0 0 0 .025.917l7.5 3a.5.5 0 0 0 .372 0L14 7.14V13a1 1 0 0 0-1 1v2h3v-2a1 1 0 0 0-1-1V6.739l.686-.275a.5.5 0 0 0 .025-.917z" />
                            <path d="M4.176 9.032a.5.5 0 0 0-.656.327l-.5 1.7a.5.5 0 0 0 .294.605l4.5 1.8a.5.5 0 0 0 .372 0l4.5-1.8a.5.5 0 0 0 .294-.605l-.5-1.7a.5.5 0 0 0-.656-.327L8 10.466z" />
                          </svg>
                        </div> */}
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="responses-card-summery">
                      <img src="/images/org-img/leave/popup-backimg.png" className="bg-img"/>
                      <h4>Closed surveys</h4>
                      <div className="d-flex justify-content-between align-items-center">
                        {/* <div className="num-bx">
                          
                          {surveySummaryList[0]?.ClosedSurveys ?? 0}
                          </div> */}
                        <div className="num-bx">
                          {surveySummaryList?.find(
                            (item) => item.Key === "Closed Surveys",
                          )?.Value ?? 0}
                        </div>

                        {/* <div className="img-bx text-dark">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            class="bi bi-stopwatch"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8.5 5.6a.5.5 0 1 0-1 0v2.9h-3a.5.5 0 0 0 0 1H8a.5.5 0 0 0 .5-.5z" />
                            <path d="M6.5 1A.5.5 0 0 1 7 .5h2a.5.5 0 0 1 0 1v.57c1.36.196 2.594.78 3.584 1.64l.012-.013.354-.354-.354-.353a.5.5 0 0 1 .707-.708l1.414 1.415a.5.5 0 1 1-.707.707l-.353-.354-.354.354-.013.012A7 7 0 1 1 7 2.071V1.5a.5.5 0 0 1-.5-.5M8 3a6 6 0 1 0 .001 12A6 6 0 0 0 8 3" />
                          </svg>
                        </div> */}
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="responses-card-summery">

                                           <img src="/images/org-img/leave/popup-backimg.png" className="bg-img"/>
                      <h4> Total Participation %</h4>
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="num-bx">
                          {surveySummaryList?.find(
                            (item) => item.Key === "Participation %",
                          )?.Value ?? 0}
                        </div>
                        {/* <div className="img-bx text-dark">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            class="bi bi-person-add"
                            viewBox="0 0 16 16"
                          >
                            <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0m-2-6a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
                            <path d="M8.256 14a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1 1z" />
                          </svg>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xl-12">
            <InfiniteScroll
              dataLength={surveyList?.length}
              next={loadMoreSurveys}
              hasMore={hasMore}
              // loader={<h5 className="text-center p-3"></h5>}
              style={{ overflow: 'visible' }}
              // endMessage={
              //   <p className="text-center p-3">
              //     <b>No more surveys to load</b>
              //   </p>
              // }
            >
              <div className="row gx-3">

               {surveyList?.map((item) => (
                <div className="col-lg-6">
                  <div className="assessment-block">
                    {/* <Link to={`/Survey/FillSurvey/${item?.FormId}`}> */}
                    <div className="illustration-header00">

                      
                      <div className="header-meta">
                        <div className="first-divblock">
                          <div>
                            <a>
                              <h3 className="survey-listtitle">{item?.Title}</h3>
                            </a>
                            <div style={{ "lineHeight": "1.2" }}>
                              <span>Closure Date :</span>
                              <span>
                                {moment(item?.ClosureDate).format(
                                  "MMM DD YYYY",
                                )}
                              </span>
                            </div>

                            <ul className="basicinfomation">
                              
                              <li>
                                <i
                                  className="fa fa-user"
                                  aria-hidden="true"
                                ></i>
                                Created By :{" "}
                                <b className="emp-count">
                                  {item?.CreatorName}
                                </b>
                              </li>

                              <li>
                                <i
                                  className="fa fa-user"
                                  aria-hidden="true"
                                ></i>
                                Responses :{" "}
                                <b className="emp-count">
                                  {item?.TotalResponses}
                                </b>
                              </li>

                              
                            </ul>
                          </div>
                          <div className="ml-auto d-flex align-items-center justify-content-end gap-2 flex-wrap">
                            {(create || update) && (item?.MyParticipation == 1) && (
                              <span
                                className="summary-stat ml-auto summary-response"
                                onClick={() =>
                                  history.push(`/Survey/Result/${item?.FormGUID}`)
                                }
                              >
                                <button className="btn btn-warning-info fs-9 py-1">
                                  Response Summary
                                </button>
                              </span>
                            )}

                            <span className="assessment-status-close me-2" style={{ color: item?.FormStatusColor }}>
                              {item?.FormStatus}
                            </span>
                            {((create && update) || item?.MyCreatedSurvey === 1) && (
                              <ul className="mb-0">
                                <li className="nav-item dropdown notification_dropdown">
                                  <a
                                    className="nav-link p-0 moremenudropdown"
                                    data-bs-toggle="dropdown"
                                    href="#"
                                  >
                                    <img
                                      src="/images/menu-icon/MoreIcon.svg"
                                      style={{
                                        width: "16px",
                                        marginRight: "6px",
                                      }}
                                      alt="More"
                                    />
                                    More
                                  </a>
                                  <div className="dropdown-menu dropdown-menu-end">
                                    <ul className="timeline">
                                      {/* {item?.FormStatusId == 101 && <li className="mb-0">
                                        <Link
                                          to={`/Survey/Update/${item?.FormGUID}`}
                                        >
                                          <img
                                            src="/images/org-img/edit.png"
                                            className="me-1"
                                          />{" "}
                                          Edit
                                        </Link>
                                      </li>} */}
                                      {item?.FormStatusId !== 104 && (
                                      <li className="mb-0">
                                      <Link to={`/Survey/Update/${item?.FormGUID}`}>
                                       <img
                                       src="/images/org-img/edit.png"
                                      className="me-1"
                                      />{" "}
                                      Edit
                                   </Link>
                                   </li>
                                    )}


                                      {/* <li className="mb-0">
                                        <a
                                         style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            StopSurveyForm(item?.FormId)
                                          }
                                        >
                                          <span className="me-1">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="16"
                                              height="16"
                                              fill="currentColor"
                                              className="bi bi-stop-circle"
                                              viewBox="0 0 16 16"
                                            >
                                              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                              <path d="M5 6.5A1.5 1.5 0 0 1 6.5 5h3A1.5 1.5 0 0 1 11 6.5v3A1.5 1.5 0 0 1 9.5 11h-3A1.5 1.5 0 0 1 5 9.5z" />
                                            </svg>
                                          </span>{" "}
                                          {item?.FormStatusId == 102 ? 'Pause' : 'Unpause'}
                                        </a>
                                      </li> */}

                                      {item?.IsPublished && (
  <li className="mb-0">
    <a
      style={{ cursor: "pointer" }}
      onClick={() => StopSurveyForm(item?.FormId)}
    >
      <span className="me-1">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-stop-circle"
          viewBox="0 0 16 16"
        >
          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
          <path d="M5 6.5A1.5 1.5 0 0 1 6.5 5h3A1.5 1.5 0 0 1 11 6.5v3A1.5 1.5 0 0 1 9.5 11h-3A1.5 1.5 0 0 1 5 9.5z" />
        </svg>
      </span>
      {item?.FormStatusId == 102 ? "Pause" : "Unpause"}
    </a>
  </li>
)}
                                      <li className="mb-0">
                                        <a
                                          style={{ cursor: "pointer" }}
                                          data-toggle="tooltip"
                                          data-placement="top"
                                          data-bs-toggle="modal"
                                          data-bs-target="#delete-ed"
                                          title=""
                                          data-bs-original-title="delete"
                                          aria-label="delete"
                                          onClick={() =>
                                            setDeleteFormId(item?.FormId)
                                          }
                                        >
                                          <img
                                            src="/images/org-img/delete.png"
                                            className="me-1"
                                          />
                                          Delete
                                        </a>
                                      </li>

                                      <li className="mb-0">
                                        <a
                                          style={{ cursor: "pointer" }}
                                          onClick={() => handlePublish(item)}>
                                          <span className="me-1">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="16"
                                              height="16"
                                              fill="currentColor"
                                              className="bi bi-send"
                                              viewBox="0 0 16 16"
                                            >
                                              <path d="M15.854.146a.5.5 0 0 0-.53-.11L.5 6.5l6.5 1.5 1.5 6.5 6.464-14.824a.5.5 0 0 0-.11-.53" />
                                              <path d="M6.832 8.168 14 1" />
                                            </svg>
                                          </span>
                                          {item?.IsPublished ? 'Unpublish' : 'Publish'}
                                        </a>
                                      </li>

                                      {/* {item?.FormStatusId == 101 && (
                                      <li className="mb-0">
                                      <a
                                        style={{ cursor: "pointer" }}
                                        // onClick={() => StopSurveyForm(item?.FormId)}
                                       >
                                      <span className="me-1">
                                     <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-stop-circle"
                                      viewBox="0 0 16 16"
                                     >
                                     <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                     <path d="M5 6.5A1.5 1.5 0 0 1 6.5 5h3A1.5 1.5 0 0 1 11 6.5v3A1.5 1.5 0 0 1 9.5 11h-3A1.5 1.5 0 0 1 5 9.5z" />
                                    </svg>
                                     </span>
                                      Preview
                                      </a>
                                  </li>
                                  )} */}
                                  {item?.IsPublished && item?.FormStatusId == 101 && (
                                   <li className="mb-0">
                                    <a style={{ cursor: "pointer" }}>
                                     <span className="me-1">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-stop-circle"
                                         viewBox="0 0 16 16"
        >
          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
          <path d="M5 6.5A1.5 1.5 0 0 1 6.5 5h3A1.5 1.5 0 0 1 11 6.5v3A1.5 1.5 0 0 1 9.5 11h-3A1.5 1.5 0 0 1 5 9.5z" />
        </svg>
      </span>
      Preview
    </a>
  </li>
)}
                                    </ul>
                                  </div>
                                </li>
                              </ul>)
                            }
                          </div>
                        </div>
                        <div className="summary-stats">
                          <div className="set-flex">
                          <div className="summary-stat">
                            <img src="/images/pms/start-date.svg" />
                            <div style={{ "lineHeight": "1.2" }}>
                              <span>Initiated On</span>
                              <span>
                                {moment(item?.InitiatedOn).format(
                                  "MMM DD YYYY",
                                )}
                              </span>
                            </div>
                          </div>
                          <div className="summary-stat">
                            <img src="/images/pms/start-date.svg" />
                            <div style={{ "lineHeight": "1.2" }}>
                              <span>Total Participation</span>
                              <span>{item?.MyParticipation}</span>
                            </div>
                          </div>

                          <div className="summary-stat">
                            <img src="/images/pms/start-date.svg" />
                            <div style={{ "lineHeight": "1.2" }}>
                              <span>Pending response</span>
                              <span>{item?.PendingPercentage}</span>
                            </div>
                          </div>
                          </div>
                          {(item?.MyParticipation == 1 || item?.FormStatusId == 104) && (
                            <div className="summary-stat ">
                              <span
                                className=" summary-response"
                                onClick={() =>
                                  history.push(`/Survey/Response/${item?.FormGUID}`)
                                }
                              >
                                <button className="btn btn-warning-info fs-9 py-1">
                                  View Response
                                </button>
                              </span>
                            </div>)}
                          {((item?.MyParticipation == 0 && item?.FormStatusId != 104 && item?.FormStatusId !=103 ) && item?.IsPublished ==true) && (
                            <div className="summary-stat">
                              <Link
                                to={`/Survey/Form/${item?.FormGUID}`}
                                className="btn btn-warning fs-9 py-1"
                              >
                                Start Survey
                              </Link>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    {/* </Link> */}
                  </div>
                </div>
              ))}
               {/* {surveyList?.length === 0 && (
                <div className="notfound">
                  <img src="/images/no-data-found/no-data.png" />
                  <h4>No survey available!</h4>
                </div>
              )} */}

              {surveyList?.length === 0 && (
              <div className="notfound">
              <img src="/images/no-data-found/no-data.png" />
              <h4>
                {searchTerm 
                   ? `No survey found ` 
                 : "No survey available!"}
                 </h4>
               </div>
               )}

              </div>
            </InfiniteScroll>
          </div>
        </div>
      </div>
      <div className="modal fade" id="delete-ed">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content delete-holiday">
            <div className="modal-header">
              <img
                src="/images/org-img/leave/popup-backimg.png"
                className="backimg"
              />
              <div className="img">
                <img src="/images/org-img/leave/trash.png" />
              </div>
            </div>
            <div className="modal-body text-center">
              <strong className="modal-title">Are you sure?</strong>
              <p>Do you really want to delete this survey?</p>
            </div>
            <div className="modal-footer m-auto">
              <button
                type="button"
                className="cancelbtn-click"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="savebtn-click"
                data-bs-dismiss="modal"
                onClick={() => DeleteSurveyForm()}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
      {IsLoading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
};
export default SurvayList;
